import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    historialEnviosMostrador:[],
  },
  mutations: {

    getEnviosMostrador(state, datos) {
      state.historialEnviosMostrador = datos;
    },

    destroyEnviosMostrador(state) {
      state.historialEnviosMostrador = [];
    },

  },
  actions: {

    async destroyEnviosMostrador({
      commit,
    }) {
      commit('destroyEnviosMostrador');
    },


    async getEnviosMostrador({
      commit,
    }, env) {
      try {
        console.log('entre');
        const res = await api.getEnviosMostrador(env);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getEnviosMostrador', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },



  },
};
